import { createFileRoute } from '@tanstack/react-router';

import { requireInvestorSession } from '@/features/investor-login/public';
import { PortfolioPage } from '@/features/portfolio/public';
import { Layout } from '@/features/portal-shell/public';

const HomePage = () => (
  <Layout>
    <PortfolioPage />
  </Layout>
);

export const Route = createFileRoute('/home')({
  staticData: { navSection: 'portfolio' },
  beforeLoad: () => requireInvestorSession(),
  component: HomePage,
});
